import { render, staticRenderFns } from "./AppTabela.vue?vue&type=template&id=908a15c8&"
import script from "./AppTabela.vue?vue&type=script&lang=js&"
export * from "./AppTabela.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports